export default function ContactUs() {
    return (
        <div style={{
            minHeight: '70vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '40px 20px',
            background: '#f9fafb'
        }}>
            <div style={{
                maxWidth: '500px',
                width: '100%',
                background: '#ffffff',
                padding: '32px',
                borderRadius: '12px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                textAlign: 'center'
            }}>
                <h1 style={{
                    marginBottom: '12px',
                    fontSize: '28px',
                    fontWeight: '600'
                }}>
                    Contact Us
                </h1>

                <p style={{
                    marginBottom: '24px',
                    color: '#555',
                    lineHeight: '1.6'
                }}>
                    We’re here to help. If you have any questions, business inquiries,
                    or need support, feel free to reach out to us using the details below.
                </p>

                <div style={{ lineHeight: '1.8', fontSize: '16px' }}>
                    <p>
                        <strong>Adresse:</strong><br />
                        Rudower Str. 132,<br />
                        12351 Berlin, Deutschland
                    </p>

                    <p>
                        <strong>Telefon:</strong><br />
                        +49 1512 3727232
                    </p>

                    <p>
                        <strong>E-Mail:</strong><br />
                        <a
                            href="mailto:info@getam.eu"
                            style={{ color: '#2563eb', textDecoration: 'none' }}
                        >
                            info@getam.eu
                        </a>
                    </p>
                </div>

                <p style={{
                    marginTop: '24px',
                    fontSize: '14px',
                    color: '#777'
                }}>
                    We usually respond within 24 hours.
                </p>
            </div>
        </div>
    );
}
